"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Slider_st_css_1 = require("./Slider.st.css");
var Thumb = /** @class */ (function (_super) {
    tslib_1.__extends(Thumb, _super);
    function Thumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Thumb.prototype.render = function () {
        var _a = this.props, shape = _a.shape, thumbSize = _a.thumbSize;
        var ThumbShape = thumbShapes[shape];
        return (React.createElement("div", { "data-hook": "thumb", className: Slider_st_css_1.classes.thumb, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, style: tslib_1.__assign(tslib_1.__assign({}, this.props.thumbPosition), thumbSize) },
            React.createElement(ThumbShape.component, null),
            this.props.children));
    };
    return Thumb;
}(React.Component));
exports.Thumb = Thumb;
function getThumbSize(shape) {
    var _a;
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    return (_a = thumbShapes[shape]).getThumbSize.apply(_a, rest);
}
exports.getThumbSize = getThumbSize;
var CircleThumb = /** @class */ (function (_super) {
    tslib_1.__extends(CircleThumb, _super);
    function CircleThumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircleThumb.prototype.render = function () {
        return (React.createElement("div", { className: Slider_st_css_1.st(Slider_st_css_1.classes.thumbShape, { shapeType: 'circle' }), style: { borderRadius: '50%' } }));
    };
    return CircleThumb;
}(React.PureComponent));
var RectangleThumb = /** @class */ (function (_super) {
    tslib_1.__extends(RectangleThumb, _super);
    function RectangleThumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RectangleThumb.prototype.render = function () {
        return (React.createElement("div", { className: Slider_st_css_1.st(Slider_st_css_1.classes.thumbShape, { shapeType: 'rectangle' }) }));
    };
    return RectangleThumb;
}(React.PureComponent));
var SquareThumb = /** @class */ (function (_super) {
    tslib_1.__extends(SquareThumb, _super);
    function SquareThumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SquareThumb.prototype.render = function () {
        return React.createElement("div", { className: Slider_st_css_1.st(Slider_st_css_1.classes.thumbShape, { shapeType: 'square' }) });
    };
    return SquareThumb;
}(React.PureComponent));
var BarThumb = /** @class */ (function (_super) {
    tslib_1.__extends(BarThumb, _super);
    function BarThumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarThumb.prototype.render = function () {
        return React.createElement("div", { className: Slider_st_css_1.st(Slider_st_css_1.classes.thumbShape, { shapeType: 'bar' }) });
    };
    return BarThumb;
}(React.PureComponent));
var thumbShapes = {
    circle: {
        component: CircleThumb,
        getThumbSize: function (sliderSize) { return ({ width: sliderSize, height: sliderSize }); },
    },
    rectangle: {
        component: RectangleThumb,
        getThumbSize: function (sliderSize, isVertical) {
            var _a;
            return (_a = {},
                _a[isVertical ? 'height' : 'width'] = 1.5 * sliderSize,
                _a[isVertical ? 'width' : 'height'] = sliderSize,
                _a);
        },
    },
    square: {
        component: SquareThumb,
        getThumbSize: function (sliderSize) { return ({ width: sliderSize, height: sliderSize }); },
    },
    bar: {
        component: BarThumb,
        getThumbSize: function (sliderSize, isVertical) {
            var _a;
            return (_a = {},
                _a[isVertical ? 'height' : 'width'] = 0.5 * sliderSize,
                _a[isVertical ? 'width' : 'height'] = sliderSize,
                _a);
        },
    },
};
//# sourceMappingURL=Thumb.js.map